// pages/languages/LanguageAdmin.js
import React, { useState, useEffect } from 'react'
import api from '../../services/api'

function LanguageAdmin() {
  const [languages, setLanguages] = useState([])
  const [name, setName] = useState('')
  const [code, setCode] = useState('')
  const [awsCode, setAwsCode] = useState('')
  const [editId, setEditId] = useState('')
  const [status, setStatus] = useState('')

  useEffect(() => {
    loadLanguages()
  }, [])

  const loadLanguages = async () => {
    try {
      const res = await api.get('/language')
      setLanguages(res.data.languages)
    } catch (err) {
      setStatus(err.response?.data?.error || 'Error')
    }
  }

  const handleCreate = async () => {
    try {
      const res = await api.post('/language', { name, code, awsCode })
      setStatus(res.data.message)
      setName('')
      setCode('')
      setAwsCode('')
      loadLanguages()
    } catch (err) {
      setStatus(err.response?.data?.error || 'Error')
    }
  }

  const handleEdit = (lang) => {
    setEditId(lang._id)
    setName(lang.name)
    setCode(lang.code)
    setAwsCode(lang.awsCode)
  }

  const handleUpdate = async () => {
    try {
      const res = await api.put('/language', { id: editId, name, code, awsCode })
      setStatus(res.data.message)
      setEditId('')
      setName('')
      setCode('')
      setAwsCode('')
      loadLanguages()
    } catch (err) {
      setStatus(err.response?.data?.error || 'Error')
    }
  }

  const handleDelete = async (id) => {
    try {
      const res = await api.delete(`/language/${id}`)
      setStatus(res.data.message)
      loadLanguages()
    } catch (err) {
      setStatus(err.response?.data?.error || 'Error')
    }
  }

  return (
    <div>
      <h2>Language Admin</h2>
      <p>{status}</p>
      <div>
        <input
          type="text"
          placeholder="Language Name"
          value={name}
          onChange={e => setName(e.target.value)}
        />
        <input
          type="text"
          placeholder="Local Code (e.g. en, de)"
          value={code}
          onChange={e => setCode(e.target.value)}
        />
        <input
          type="text"
          placeholder="AWS Code (e.g. en-US, de-DE)"
          value={awsCode}
          onChange={e => setAwsCode(e.target.value)}
        />
        {editId ? (
          <button onClick={handleUpdate}>Update</button>
        ) : (
          <button onClick={handleCreate}>Create</button>
        )}
      </div>
      <ul>
        {languages.map(lang => (
          <li key={lang._id}>
            {lang.name} ({lang.code}) [AWS: {lang.awsCode}]
            <button onClick={() => handleEdit(lang)}>Edit</button>
            <button onClick={() => handleDelete(lang._id)}>Delete</button>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default LanguageAdmin